var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
var ChevronDown12 = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentcolor' : _b, _c = _a.height, height = _c === void 0 ? '12px' : _c, _d = _a.width, width = _d === void 0 ? '12px' : _d, rest = __rest(_a, ["color", "height", "width"]);
    var svgStyle = __assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" }, { fill: color });
    return (React.createElement("div", __assign({ style: __assign({ "position": "relative" }, { height: height, width: width }) }, rest),
        React.createElement("svg", { viewBox: "0 0 12 12", style: svgStyle },
            React.createElement("path", { d: "M1.266 3.735l-.532.53L5.956 9.5l5.307-5.234-.526-.534-4.776 4.71z" }))));
};
ChevronDown12.displayName = 'ChevronDown12';
export default ChevronDown12;
//# sourceMappingURL=chevron-down-12.js.map